<template>
  <div id="video">
    <div class="feature mainWidth">
      <mu-row gutter class="feature_box">
        <mu-col width="100" tablet="100" desktop="100" class="video_box">
         <comvideoplayer :video="video" v-if="video.videourl"></comvideoplayer>
          <p class="intro" v-html="video.describes"></p>
        </mu-col>
      </mu-row>
    </div>
  </div>
</template>

<script>
  import comvideoplayer from '../components/comvideoplayer.vue'
  export default {
    name: 'erange',
    data () {
      return {
        activeTab:'0',
        id:this.$route.params.id,
        video:{},
      }
    },
    created(){
      this.reqVideo();
    },
    methods:{
      reqVideo(){ //请求视频
        this.$http({
          root:'http://www.supershooter.cn:8099/webapi/VideoDetails',
          method:'post',
          params:{
            videoid:this.id
          }
        }).then((res)=>{
          this.sw=true;
          console.log(res.body);
          if(res.body.code==200){
            console.log(res.body.data);
            this.video=res.body.data;
          }else{
            this.showErr(res);
          }
        },(res)=>{
          this.showErr(res);
        });
      },
      changeTab(idx){  //tab切换
        this.activeTab=idx;
      },
    },
    components:{comvideoplayer}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  #video{
    padding-bottom: 60px;
    background-color:#e6e6e6;
    overflow:hidden;
    .banner{
      height:414px;
      margin:0 auto;
      background:url("../../static/guanyu-banner.png") no-repeat center center;
      background-size:auto 100%;
      position:relative;
      .content_box{
        width:1200px;
        height:auto;
        background-color:rgba(54,177,255,0.51);
        border-left:10px solid #6FA0FF;
        color:#FFF;
        padding:40px 60px 40px 95px;
        .logo{
          display:block;
          margin-bottom:20px;
          >img{
            width:132px;
            height:20px;
          }
        }
        >p{
          font-family: PingFangSC-Regular;
          text-align:justify;
          font-size: 14px;
          color: #FFFFFF;
          letter-spacing: 0;
          line-height: 27px;
        }
      }
    }
    .feature{
      margin-top:17px;
      clear:both;
      .feature_box{
        overflow:hidden;
        background:#FFF;
        min-height:600px;
        .video_box{
          width:750px;
          height:auto;
          margin:75px auto;
          margin-bottom:25px;
          .intro{
            font-family: PingFangSC-Regular;
            text-align:justify;
            font-size: 14px;
            color: #666666;
            letter-spacing: 0;
            line-height: 25px;
          }

        }
      }
    }



  }

</style>




// WEBPACK FOOTER //
// src/page/video.vue